import React, { useState } from 'react';
import { Card, CardContent, Typography } from "@mui/material";
import Div from "@jumbo/shared/Div";
import Link from "@mui/material/Link";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import InputForm from 'app/components/InputForm/InputForm';
import ButtonStyled from 'app/components/ButtonStyled/ButtonStyled';
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import { requestApi } from 'app/utils/RestApi';
import { VisibilityOff } from '@mui/icons-material';
import { AUTH, CAPTCHA } from 'app/utils/constants/endPoint';
import { AUTH_SAVE } from 'app/redux/actions/constant';
import { connect } from 'react-redux';
import { useProgram } from 'app/hooks/useProgram';
import { clearUserSession, removeOtpSession } from '@jumbo/components/JumboAuthProvider/authHelpers';
import schemaLogin, { initialValues } from './schema';
import { Field, Formik } from 'formik';
import appConfig from 'app/config/appConfig';
import { encryptPayload } from 'app/utils/appHelpers';
import useRecaptcha from 'app/hooks/useRecaptcha';
import ReCAPTCHA from 'react-google-recaptcha';
import { getMfaCookies, getOrCreateUid, clearMfaCookies } from 'app/utils/mfaCookies';
import { verifyToken as mfaVerifyToken, reqOtp as mfaReqOtp, fetchMfaChoiceFlag } from 'app/services/mfaService';

const MicrositeLogin = (props) => {
	const navigate = useNavigate();

	const program = useProgram();

	const [pwdType, setPwdType] = useState('password');

	const { captchaToken, recaptchaRef, handleRecaptcha } = useRecaptcha();

	const [fieldTouched, setFieldTouched] = useState({
		username: false,
		password: false
	});

	React.useEffect(() => {
		clearUserSession();
		removeOtpSession();
	}, [])

	const touchForm = (field) => {
		if (!fieldTouched[field]) {
			setFieldTouched((prevState) => ({ ...prevState, [field]: true }))
		}
	};

	const sendData = async (dataForm) => {
		await Swal.fire({
			title: 'Mohon Tunggu..',
			timerProgressBar: true,
			didOpen: async () => {
				Swal.showLoading()

				const uidForLogin = getOrCreateUid(dataForm.username || '')
				const encryptedPayload = encryptPayload({ ...dataForm, uid: uidForLogin })
				try {
					const res = await requestApi(CAPTCHA.VERIFY_V2, {
						data: {
							captchaToken
						}
					})

					if (res?.status == 200) {
						const { data } = await requestApi(AUTH.LOGIN, {
							data: {
								data: encryptedPayload
							}
						})
						console.log("res LOGIN : ", data);

						Swal.close();
						if (data?.status === 'success') {
							sessionStorage.setItem("auth", 1)

							//storing data auth
							const { username, isVerified, userLoggedin, isRegistered, token, program, hasMconnectUpdate } = data.data
							props.dispatch({ type: AUTH_SAVE, payload: { username, isVerified, userLoggedin, isRegistered } })

							//storing token
							localStorage.setItem("token", token)
							localStorage.setItem("username", username)
							localStorage.setItem("program", program)
							localStorage.setItem("userdata", JSON.stringify({ username, isVerified, userLoggedin, isRegistered, token, email: userLoggedin?.email, name: userLoggedin?.name }))
							// setAuthToken(data.token)


							// Determine the post-MFA destination based on existing flow rules.
							let nextRoute = '/micrositeNews'
							if (!userLoggedin?.pwdChangedDate) {
								localStorage.setItem("temp_token", token)
								nextRoute = '/micrositeKonfirmasiBelumRegis'
							} else if (!isRegistered) {
								localStorage.setItem("temp_token", token)
								nextRoute = '/micrositeTnCRegis'
							} else if (hasMconnectUpdate) {
								localStorage.setItem("otpOnly", '1')
								nextRoute = '/micrositeOtp'
							}
							localStorage.setItem('post_mfa_next', nextRoute)

							await runPostLoginMfa({
								identifier: userLoggedin?.email,
								name: userLoggedin?.name,
								nextRoute,
							})
						}
					} else {
						Swal.fire({
							icon: 'warning',
							text: res?.data,
							allowOutsideClick: false,
							confirmButtonColor: 'red'
						})
					}
				} catch (error) {
					Swal.close()
					if (error?.status === 423) {
						Swal.fire({
							icon: 'warning',
							title: 'Akun Diblokir Sementara',
							text: error?.message || 'Terlalu banyak percobaan. Silakan coba lagi dalam beberapa saat.',
							allowOutsideClick: false,
							confirmButtonColor: 'red'
						})
						return
					}
					Swal.fire({
						icon: 'warning',
						text: error?.message || 'Failed to login',
						allowOutsideClick: false,
						confirmButtonColor: 'red'
					})
				}
			},
			showCloseButton: false,
			showConfirmButton: false,
			allowOutsideClick: false
		})

	}

	const runPostLoginMfa = async ({ identifier, name, nextRoute }) => {
		// Username for MFA payloads is the referrer's `name` field.
		const username = name
		const uid = getOrCreateUid(identifier)
		const cookies = getMfaCookies(identifier)

		if (cookies.uid && cookies.token) {
			try {
				const { data } = await mfaVerifyToken({ identifier, username, uid: cookies.uid, token: cookies.token })
				if (data?.status === 'Ok' || data?.status === 'Bypassed') {
					navigate(nextRoute)
					return
				}
				clearMfaCookies(identifier)
			} catch (error) {
				console.warn("MFA Verify Token Error: ", error);
				clearMfaCookies(identifier)
			}
		}

		let showChoicePage = false
		try {
			const flagRes = await fetchMfaChoiceFlag()
			showChoicePage = !!flagRes?.data?.data?.value?.enabled
		} catch (error) {
			console.warn("MFA Fetch Choice Flag Error: ", error);
			showChoicePage = false
		}

		if (showChoicePage) {
			localStorage.removeItem('mfa_ttl_exp')
			localStorage.setItem('mfa_pending', '1')
			navigate('/mfaChoice')
			return
		}

		try {
			const reqRes = await mfaReqOtp({ identifier, username, type: 'email', uid })
			const data = reqRes?.data || {}
			if (data.status === 'Bypassed') {
				navigate(nextRoute)
				return
			}
			const ttl = parseInt(data?.data?.TTL, 10) || 300
			if (data.status === 'Blocked') {
				localStorage.setItem('mfa_block_exp', String(Date.now() + ttl * 1000))
				localStorage.setItem('mfa_block_msg', data.message)
				Swal.fire({
					icon: 'warning',
					title: 'Limit pengiriman OTP',
					text: data.message,
					allowOutsideClick: false,
					confirmButtonColor: 'red'
				})
				return
			}
			localStorage.setItem('mfa_ttl_exp', String(Date.now() + ttl * 1000))
			localStorage.setItem('mfa_channel', 'email')
			localStorage.setItem('mfa_pending', '1')
			navigate('/verifyMfa')
		} catch (error) {
			Swal.fire({
				icon: 'warning',
				text: error?.message || 'Failed to send OTP',
				allowOutsideClick: false,
				confirmButtonColor: 'red'
			})
		}
	}

	const visibilityPwd = React.useCallback(
		() => {
			if (pwdType === 'password') {
				return (
					<VisibilityOff onClick={() => setPwdType('text')} sx={{ fontSize: 25 }} />
				)
			}

			return (
				<VisibilityOutlinedIcon onClick={() => setPwdType('password')} sx={{ fontSize: 25 }} />
			)
		},
		[pwdType],
	)

	const toLupaPass = () => {
		navigate('/micrositeLupaPassword')
	};

	return (
		<Card
			sx={{
				display: 'flex',
				flexDirection: { xs: 'column', md: 'row' },
				borderRadius: 10,
				boxShadow: '0 30px 35px 0 rgba(0, 0, 0, 0.3)',
			}}
			className='login-card'
		>
			<CardContent
				sx={{
					flex: '1',
					position: 'relative',
					padding: 0
				}}
			>
				<Div
					sx={{
						display: 'flex',
						minWidth: 0,
						flex: 1,
						flexDirection: 'column',
						color: 'common.black',
						position: 'relative',
						zIndex: 1,
						height: '100%'
					}}
				>
					<Div sx={{ mb: 1 }}>
						<Typography variant={"h3"} fontWeight={400} mb={1}>Selamat Datang </Typography>
						<Typography variant={"h1"} fontWeight={600} mb={2} fontSize={30}>{program}</Typography>
					</Div>
					<Formik
						initialValues={initialValues}
						enableReinitialize={true}
						validationSchema={schemaLogin}
						validateOnMount
						onSubmit={(values) => {
							sendData(values)
						}}
					>
						{({ errors, touched, handleSubmit }) => {
							return (
								<Div sx={{ mt: 1, mb: 3 }} className='form-layout'>
									<Field name="username">
										{({
											form: { handleChange },
											meta,
										}) => (
											<Div sx={{ mb: 3 }}>
												<InputForm
													required
													inputLabel={"Masukan alamat email Anda"}
													type="email"
													name="username"
													value={meta.value}
													onChange={handleChange}
													onBlur={() => touchForm('username')}
													placeholder={"Alamat Email"}
												/>
												{(fieldTouched.username && meta.error) && <span style={{ color: 'red' }}>{meta.error}</span>}
											</Div>
										)}
									</Field>
									<Field name="password">
										{({
											form: { handleChange },
											meta,
										}) => (
											<Div sx={{ mb: 1 }}>
												<InputForm
													required
													inputLabel={"Masukan kata sandi Anda"}
													placeholder={"Kata Sandi"}
													type={pwdType}
													name="password"
													value={meta.value}
													onChange={handleChange}
													onBlur={() => touchForm('password')}
													rightIcon={visibilityPwd()}
												/>
												{(fieldTouched.password && meta.error) && <span style={{ color: 'red' }}>{meta.error}</span>}
											</Div>
										)}
									</Field>
									<Typography
										textAlign={"right"}
										variant={"body1"}
									>
										<Link underline="" sx={{ cursor: "pointer" }} onClick={toLupaPass} color={"#C21B17"} >Lupa Kata Sandi?</Link>
									</Typography>
									<Div sx={{ mt: 2 }}>
										<ReCAPTCHA
											ref={recaptchaRef}
											sitekey={appConfig.GOOGLE_CAPTCHA_SITE_KEY}
											onChange={handleRecaptcha}
										/>
									</Div>
									<Div sx={{ mt: 2 }}>
										<ButtonStyled
											disabled={(Object.values(errors).length > 0) || !captchaToken}
											onClick={handleSubmit}
											btnText={"Masuk"}
											preset={"primary"}
											sx={{ minWidth: '164px' }}
										/>

									</Div>
								</Div>
							)
						}}
					</Formik>
				</Div>
			</CardContent>
		</Card>
	);
};


const mapStateToProps = state => ({
	authMicrosite: state.authMicrosite
});

export default connect(mapStateToProps)(MicrositeLogin);